import React, { useState } from 'react';
import { Modal } from './Modal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  const currentYear = new Date().getFullYear();
  return <>
      <footer className="py-12 border-t border-white/5 bg-[#0D0D0D] text-center" data-id="element-28">
        <div className="max-w-4xl mx-auto px-4" data-id="element-29">
          <p className="text-[#9A948C] text-sm mb-4" data-id="element-30">
            © {currentYear} No Le Escribas. Todos los derechos reservados.
          </p>

          <div className="flex flex-wrap justify-center gap-6 text-sm" data-id="element-31">
            <button onClick={() => setActiveModal('privacy')} className="text-[#9A948C] hover:text-[#A52422] transition-colors underline decoration-transparent hover:decoration-[#A52422] underline-offset-4" data-id="element-32">
              Política de Privacidad
            </button>
            <button onClick={() => setActiveModal('terms')} className="text-[#9A948C] hover:text-[#A52422] transition-colors underline decoration-transparent hover:decoration-[#A52422] underline-offset-4" data-id="element-33">
              Términos y Condiciones
            </button>
          </div>

          
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-34">
        <div className="space-y-4 text-sm" data-id="element-35">
          <p data-id="element-36">
            <strong data-id="element-37">Última actualización: {currentYear}</strong>
          </p>

          <h3 className="text-white font-bold text-base mt-4" data-id="element-38">
            1. Información que recopilamos
          </h3>
          <p data-id="element-39">
            Recopilamos información que usted nos proporciona directamente
            cuando realiza una compra, se suscribe a nuestro boletín o se
            comunica con nosotros. Esta información puede incluir su nombre,
            dirección de correo electrónico y detalles de pago.
          </p>

          <h3 className="text-white font-bold text-base mt-4" data-id="element-40">
            2. Uso de la información
          </h3>
          <p data-id="element-41">
            Utilizamos la información que recopilamos para procesar sus
            transacciones, enviarle el contenido digital adquirido y
            comunicarnos con usted sobre nuestros productos y servicios. No
            vendemos ni compartimos su información personal con terceros para
            fines de marketing.
          </p>

          <h3 className="text-white font-bold text-base mt-4" data-id="element-42">
            3. Seguridad de los datos
          </h3>
          <p data-id="element-43">
            Implementamos medidas de seguridad razonables para proteger su
            información personal contra acceso no autorizado, alteración o
            destrucción. Sin embargo, ningún método de transmisión por Internet
            es 100% seguro.
          </p>

          <h3 className="text-white font-bold text-base mt-4" data-id="element-44">4. Cookies</h3>
          <p data-id="element-45">
            Utilizamos cookies y tecnologías similares para mejorar su
            experiencia en nuestro sitio web y analizar cómo se utiliza nuestro
            servicio. Puede configurar su navegador para rechazar todas las
            cookies o para que le avise cuando se envíe una cookie.
          </p>
        </div>
      </Modal>

      {/* Terms Modal */}
      <Modal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-46">
        <div className="space-y-4 text-sm" data-id="element-47">
          <p data-id="element-48">
            <strong data-id="element-49">Última actualización: {currentYear}</strong>
          </p>

          <h3 className="text-white font-bold text-base mt-4" data-id="element-50">
            1. Aceptación de los términos
          </h3>
          <p data-id="element-51">
            Al acceder y utilizar este sitio web y comprar nuestros productos
            digitales, usted acepta estar sujeto a estos Términos y Condiciones.
            Si no está de acuerdo con alguna parte de estos términos, no debe
            utilizar nuestros servicios.
          </p>

          <h3 className="text-white font-bold text-base mt-4" data-id="element-52">
            2. Propiedad Intelectual
          </h3>
          <p data-id="element-53">
            Todo el contenido incluido en este sitio, como texto, gráficos,
            logotipos, imágenes y descargas digitales, es propiedad de "No Le
            Escribas" y está protegido por las leyes de propiedad intelectual.
            La compra de nuestros productos le otorga una licencia personal y no
            transferible para su uso privado. Queda estrictamente prohibida su
            distribución, reventa o uso comercial.
          </p>

          <h3 className="text-white font-bold text-base mt-4" data-id="element-54">
            3. Política de Reembolso
          </h3>
          <p data-id="element-55">
            Debido a la naturaleza digital de nuestros productos, todas las
            ventas son finales. Sin embargo, si experimenta problemas técnicos
            para acceder al contenido, por favor contáctenos para recibir
            asistencia.
          </p>

          <h3 className="text-white font-bold text-base mt-4" data-id="element-56">
            4. Descargo de Responsabilidad
          </h3>
          <p data-id="element-57">
            El contenido proporcionado en nuestros productos es solo para fines
            informativos y educativos. No sustituye el asesoramiento profesional
            psicológico o médico. El uso de la información proporcionada es bajo
            su propia responsabilidad.
          </p>
        </div>
      </Modal>
    </>;
}